// Pins the document behind a sheet. `overflow: hidden` on <body> is ignored by
// iOS Safari for touch scrolling, so the body is fixed in place at its current
// scroll offset and put back on release. Several sheets can hold the lock at
// once — Casey under a form sheet, say — and the page unpins only when the
// last holder lets go. Holders are the sheets' elements: one that has left
// the document cannot keep the page pinned.
const holders = new Set<Element>()
let scrollY = 0

export function lockPage(holder: Element): void {
  prune()
  if (holders.size === 0) pin()
  holders.add(holder)
}

export function unlockPage(holder: Element): void {
  holders.delete(holder)
  prune()
  if (holders.size === 0 && document.body.style.position === "fixed") unpin()
}

function prune(): void {
  holders.forEach((holder) => {
    if (!holder.isConnected) holders.delete(holder)
  })
}

function pin(): void {
  const body = document.body
  // Refuse the document's pull-to-refresh while a sheet is open: a downward
  // drag with the sheet's scroller already at the top arms Safari's refresh
  // gesture, and a pull that is started but abandoned leaves the sheet unable
  // to scroll at all.
  document.documentElement.style.overscrollBehavior = "none"
  scrollY = window.scrollY
  body.style.position = "fixed"
  body.style.top = `-${scrollY}px`
  body.style.left = "0"
  body.style.right = "0"
  body.style.width = "100%"
}

function unpin(): void {
  const body = document.body
  document.documentElement.style.overscrollBehavior = ""
  body.style.position = ""
  body.style.top = ""
  body.style.left = ""
  body.style.right = ""
  body.style.width = ""
  window.scrollTo(0, scrollY)
}
